import React from "react";
import {
  FiPhoneCall,
  FiMessageCircle,
  FiMail,
  FiArrowUpRight,
} from "react-icons/fi";
import "./AgentStickyCard.css";
import apis from "../../utils/apis";
import whatsappLink from "../../utils/whatsappLink";
import httpAction from "../../utils/httpAction";

export default function AgentStickyCard({ agent, id }) {
  const callClickHandler = async () => {
    const data = {
      url: apis().lisitingAddClick + "?id=" + id,
      method: "PUT",
    };

    await httpAction(data);
  };

  return (
    <aside className="asc">
      <div className="asc__card">
        <div className="asc__top">
          <img
            className="asc__img"
            src={apis().localUrl + agent?.imageUrl}
            alt={agent?.name}
          />
          <div>
            <div className="asc__name">{agent?.name}</div>
            <div className="asc__role">{agent?.desigination}</div>
            <div className="asc__meta">{agent?.experience} Year Experience</div>
          </div>
        </div>

        <div className="asc__row">
          <a
            onClick={callClickHandler}
            className="asc__action"
            href={`tel:${agent?.mobile}`}
          >
            <FiPhoneCall /> Call
          </a>
          <a
            onClick={() => {
              callClickHandler();
              window.location.href = whatsappLink(
                agent?.mobile,
                "Hello, Iam intrested in this property",
                window.location.href
              );
            }}
            className="asc__action"
            target="__blank"
          >
            <FiMessageCircle /> WhatsApp
          </a>
        </div>

        <a
          onClick={() => {
            callClickHandler();
            window.location.href = whatsappLink(
              agent?.mobile,
              "Hello, Iam intrested in this property",
              window.location.href
            );
          }}
          target="__blank"
        >
          <button className="asc__cta" type="button">
            Book a Visit <FiArrowUpRight />
          </button>
        </a>

        <div className="asc__hint">
          We respond fast. Share your budget + preferred location for better
          options.
        </div>
      </div>
    </aside>
  );
}
